import * as yup from 'yup';

export const numberOfEmployeesSimpleValidationSchema = yup
  .number()
  .integer()
  .typeError('Must be a valid number')
  .positive('Should be positive')
  .nullable();
